import { config } from 'data';
import { invoiceService } from 'services';
import { useQuery } from 'hooks';

const useInvoiceBasicQuery = (displayId?: string) => useQuery({
  queryKey: [config.INVOICE_QUERY_KEY, displayId],
  queryFn: () => displayId ? invoiceService.getInvoiceBasic(displayId) : null,
});

export default useInvoiceBasicQuery;
